import type { CommentData } from '@/api/getCommentList';
import { SELECTOR } from '@/constants';

import { CommentCard } from '../../molecule/CommentCard';

interface CommentSkeletonProps {
  initialData?: CommentData;
}

export const CommentSkeletons = ({ initialData }: CommentSkeletonProps) => {
  const { commentList } = initialData ?? {};

  return (
    <section
      className="bg-Gray-white px-16 py-24"
      id={SELECTOR.COMMENT_LIST_TOP}
    >
      <header className="my-16 h-53">
        <strong className="my-16 font-600 text-Gray-900 typo-body4">
          댓글 -
        </strong>
      </header>
      <ul className="flex flex-col gap-24">
        {commentList?.map((comment) => (
          <li key={comment.commentId}>
            <CommentCard comment={comment} />
          </li>
        ))}
      </ul>
    </section>
  );
};
